export enum PERMISSION_GROUPS {
    Company = "company",
    Device = "device",
    DeviceGroup = "device group",
    File = "file",
    Role = "role",
    Task = "task",
    TaskGroup = "task group",
    Token = "token",
    User = "user"
}

export enum PERMISSIONS {
    CompanyCreate = "Company.Create",
    CompanyDelete = "Company.Delete",
    CompanyMerge = "Company.Merge",
    CompanyUpdate = "Company.Update",
    DeviceExport = "Device.Export",
    DeviceRead = "Device.Read",
    DeviceSecretsRead = "Device.SecretsRead",
    DeviceTransfer = "Device.Transfer",
    DeviceUnlock = "Device.Unlock",
    DeviceUpdate = "Device.Update",
    DeviceGroupCreate = "DeviceGroup.Create",
    DeviceGroupDelete = "DeviceGroup.Delete",
    DeviceGroupRead = "DeviceGroup.Read",
    DeviceGroupUpdate = "DeviceGroup.Update",
    FileCreate = "File.Create",
    FileDelete = "File.Delete",
    FileDownload = "File.Download",
    FileRead = "File.Read",
    FileUpdate = "File.Update",
    FileTctWebAccess = "File.TctWebAccess",
    RoleCreate = "Role.Create",
    RoleRead = "Role.Read",
    RoleUpdate = "Role.Update",
    RoleDelete = "Role.Delete",
    TaskCreate = "Task.Create",
    TaskRead = "Task.Read",
    TaskRetry = "Task.Retry",
    TaskUpdate = "Task.Update",
    TaskGroupRead = "TaskGroup.Read",
    TctIntegrationAccess = "TctIntegration.Access",
    TokenCreate = "Token.Create",
    TokenDelete = "Token.Delete",
    TokenRead = "Token.Read",
    UserCreate = "User.Create",
    UserDelete = "User.Delete",
    UserRead = "User.Read",
    UserUpdate = "User.Update"
}
